import { ref, onBeforeMount } from 'vue'
import { queryGoodsOption } from '@/api/goodsSetting'
export default function () {
  const productList = ref([])
  const isProductListLoading = ref(true)

  const getProductList = async () => {
    try {
      isProductListLoading.value = true
      const { code, data } = await queryGoodsOption()
      if (code === '0') {
        productList.value =
          data?.map((item: Record<string, any>) => ({
            ...item,
            filePath: item.extData?.filePath || '-',
          })) ?? []
      }
    } catch (e) {
      console.log(e)
    } finally {
      isProductListLoading.value = false
    }
  }

  onBeforeMount(() => {
    getProductList()
  })

  return {
    productList,
    isProductListLoading,
  }
}
